module.exports = __webpack_public_path__ + "static/media/16mb.92d35683.mp4";